<template>
    <c-modal @close="close" :title="'Reparatieverzoek'">

        <c-form ref="form" @valid="submit" class="margin-t-40">

            <c-checkbox v-if="!repairDetailView"
                id="defective-article"
                v-model="defectiveArticle"
                :horizontal="true"
                :label="'Defect artikel'"
                :labeltext="'product.name'"
                :options="items"
                :ValueName="'id,product_id'"
                required>
            </c-checkbox>

            <c-textarea
                :label="'Omschrijving'"
                :horizontal="true"
                type="text"
                name="description"
                v-model="description"
                autocomplete="description"/>

            <div class="margin-t-40" v-if="!repairDetailView">

                <div v-if="edit">
                    <c-replacing-item
                        v-for="product in ReplacingArticle" :key="product"
                        @delete-item="removeItem"
                        ref="items"
                        :items="products"
                        :edit="true"
                        :product="product">
                    </c-replacing-item>
                </div>
                <c-replacing-item
                    v-for="count in itemCount" :key="count"
                    @delete-item="removeItem"
                    ref="items"
                    :items="products">
                </c-replacing-item>

                <a @click="addItem"
                   class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
                    <svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <path
                                d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1"
                                id="plus"/>
                        </defs>
                        <use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/>
                    </svg>
                    <span>Nog een artikel toevoegen</span>
                </a>

            </div>

            <div v-if="!repairDetailView">
            <div class="margin-t-40"/>

                <c-datepicker
                    :label="'Ophaaldatum'"
                    :horizontal="true"
                    :icon="true"
                    name="date"
                    v-model="datePickup"
                    :type="'future'">
                </c-datepicker>

                <c-custom-zipcode-address
                    :label="'Ophaallocatie'"
                    :addresses="addresses"
                    v-model="pickUpAddress"
                    name="address"
                />
                <div class="margin-t-40"/>

                <c-input
                    label="Ordernummer"
                    :horizontal="true"
                    name="orderNumber"
                    v-model="orderNumber"
                    required
                />

                <c-input
                    label="Uw referentie"
                    :horizontal="true"
                    name="yourReference"
                    v-model="yourReference"
                    required
                />

                <h6 class="c-text-icon margin-t-24 margin-b-16">
                    Contact gegevens
                </h6>
				<c-input
					:label="'E-mailadres'"
					:horizontal="true"
					type="text"
					name="email"
					v-model="email"
					required/>

                    <c-input
					:label="'Telefoonnummer'"
					:horizontal="true"
					type="text"
					name="phone"
					v-model="phone"
					required/>

            </div>

            <div class="row collapse align-right">
                <div class="columns shrink">
                    <c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Bevestigen</c-button>
                </div>
            </div>

        </c-form>

    </c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CReplacingItem from '@components/ReplacingItem';
import CDatepicker from '@components/form/input/Datepicker';
import CCustomZipcodeAddress from '@components/CustomZipcodeAddress.vue';
import {ValidationError} from '@app/errors';

export default {
    mixins: [Form],
    components: {
        CModal, CReplacingItem, CDatepicker, CCustomZipcodeAddress
    },
    props: {
        addresses: {
            required: false,
            type: Array
        },
        items: {
            required: false
        },
        parent_client_id: {
            required: false
        },
        client_id: {
            required: false
        },
        edit: {
            default: false
        },
        delivery: {
            required: false
        },
        repairDetailView: {
            default: false
        }
    },
    data() {
        return {
            defectiveArticle: [],
            ReplacingArticle: [],
            datePickup: '',
            pickUpAddress: {},
            products: '',
            itemCount: 1,
            description: '',
            orderNumber: '',
            yourReference: '',
            email: '',
            phone: ''
        };
    },
    watch: {},
    methods: {
        addItem() {
            this.itemCount++;
        },
        removeItem() {
            this.itemCount--;
        },
        submit() {
            let data = "";

            if(this.repairDetailView){
                data = {
                    description: this.description,
                    delivery_type_id: this.$constants.delivery.REPARATIE,
                    client_id: this.delivery.client_id,
                    date: this.delivery.date,
                    address: this.pickUpAddress,
                    onlyChangeDescription: true
                }
            }
            else {

                let submitData = {
                    date: this.datePickup,
                    delivery_type_id: this.$constants.delivery.REPARATIE,
                    client_id: this.client_id,
                    description: this.description,
                    order_number: this.orderNumber,
                    your_reference: this.yourReference,
                    contact_email: this.email,
				    contact_phone: this.phone
                }

                let address = {
                    address: this.pickUpAddress,
                }

                let ItemsData = {
                    items: []
                };
                let ReplacingData = {
                    products: []
                };

                this.defectiveArticle.forEach((component, index) => {
                    let item = '';
                    item = this.defectiveArticle[index].split(' ');
                    ItemsData['items'][index] = {item_id: item[0], product_id: item[1], is_pickup: 1};
                });

                this.$refs.items.forEach((component, index) => {
                    if (component.getData()) {
                        ReplacingData['products'][index] = {product_id: component.getData(), is_pickup: 0};
                    }
                });

                
                if (ReplacingData['products'].length == 0) {
                    data = Object.assign(submitData, ItemsData, address);
                } else {
                    data = Object.assign(submitData, ItemsData, ReplacingData, address);
                }
            }

            if (this.edit) {
                this.$xhr.put('/api/deliveries/' + this.delivery.id, data).then(({result}) => {
                    this.close();
                    this.$emit('added');
                    this.$store.dispatch('toast/success', {
                        title: 'Reparatieverzoek wijzigen',
                        text: 'Het reparatieverzoek is gewijzigd'
                    });
                }).catch((e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.$store.dispatch('toast/alert', {
                        title: 'Reparatieverzoek wijzigen',
                        text: 'Er is helaas iets fout gegaan bij het wijzigen'
                    });
                });
            } else {
                data.carrier_id = 1;
                this.$xhr.post('/api/deliveries', data).then(({result}) => {
                    this.close();
                    this.$emit('added');
                    this.$refs.form.reset();
                    this.$store.dispatch('toast/success', {
                        title: 'Reparatieverzoek aanmaken',
                        text: 'Het reparatieverzoek is aangemaakt'
                    });
                }).catch((e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.$store.dispatch('toast/alert', {
                        title: 'Reparatieverzoek aanmaken',
                        text: 'Er is helaas iets fout gegaan bij het reparatieverzoek'
                    });
                });
            }

        },
        close() {
            this.$emit('close');
        },
        load() {
            if (this.parent_client_id) {
                this.$xhr.get('/api/clients/' + this.parent_client_id).then(({result}) => {
                    this.products = result.available_products;
                }).catch((e) => {
                });
                if (!this.products.length) {
                    this.$xhr.get('/api/clients/' + this.client_id).then(({result}) => {
                        this.products = result.available_products;
                    }).catch((e) => {
                        this.$store.dispatch('toast/alert', {
                            title: 'Foutmelding',
                            text: 'Producten kunnen niet worden ingeladen'
                        });
                    });
                }
            }
        }
    },
    mounted() {
        this.load();
        if (this.edit) {
            this.itemCount = 0;
            this.description = this.delivery.description;
            this.datePickup = this.delivery.date;
            this.pickUpAddress = this.delivery.address;
            this.orderNumber = this.delivery.order_number;
            this.yourReference = this.delivery.your_reference;
            this.email = this.delivery.contact_email;
            this.phone = this.delivery.contact_phone;
            this.delivery.items.forEach((component, index) => {
                let item = this.delivery.items[index].id + " " + this.delivery.items[index].product.id
                this.defectiveArticle.push(item);
            });
            this.delivery.products.forEach((component, index) => {
                if (this.delivery.products[index].pickup.is_pickup === 0)
                    this.ReplacingArticle.push(this.delivery.products[index]);
            });
        }
    }
}
</script>
